import styled from 'styled-components';

const sessionColors = {
  teal: {
    dark: '#0B5654',
    base: '#1C6F6A',
    light: '#E8F3F2',
    border: '#BCD8D5'
  },
  purple: {
    dark: '#6D48B8',
    base: '#8B5CF6',
    light: '#F1ECFB',
    border: '#D9CAF2'
  },
  orange: {
    dark: '#D97706',
    base: '#F2994A',
    light: '#FDECD8',
    border: '#F7D3AC'
  },
  pink: {
    dark: '#BE4778',
    base: '#E0729A',
    light: '#FBE9F0',
    border: '#F2C1D5'
  },
  green: {
    dark: '#2F855A',
    base: '#4CAF82',
    light: '#E8F6EE',
    border: '#BFE4CF'
  },
  gray: {
    dark: '#6B7280',
    base: '#7C8A89',
    light: '#F3F4F6',
    border: '#E5E7EB'
  }
};

const getSessionColor = (variant = 'teal', key = 'base') => {
  return sessionColors[variant]?.[key] || sessionColors.teal[key];
};

export const clinicalHistoryModalStyles = {
  overlay: {
    zIndex: 2147483600,
    backgroundColor: 'rgba(15, 23, 42, 0.45)',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center',
    paddingTop: '76px',
    overflowY: 'auto',
    overflowX: 'hidden'
  },
  content: {
    position: 'relative',
    inset: 'auto',
    border: 'none',
    background: 'transparent',
    padding: 0,
    overflow: 'visible',
    width: 'calc(100vw - 48px)',
    maxWidth: '980px',
    margin: '0 auto 48px',
    boxShadow: 'none'
  }
};

export const ClinicalHistoryPage = styled.div`
  width: 100%;
  max-width: 100vw;
  padding: 12px 14px 48px;
  box-sizing: border-box;
  overflow-x: hidden;
`;

export const ClinicalHistoryCard = styled.div`
  width: 100%;
  max-width: 1220px;
  margin: 0 auto;
  box-sizing: border-box;
`;

export const ClinicalHistoryInfoBar = styled.div`
  width: 100%;
  margin-bottom: 14px;
  padding: 10px 14px;
  border-radius: 12px;
  background: #F8FAFC;
  color: #555;
  font-size: 13px;
  border: 1px solid #E5E7EB;
  box-sizing: border-box;
`;

export const ClinicalFiltersBar = styled.div`
  width: 100%;
  margin: 0 0 14px;
  padding: 14px 16px;
  background: #FFFFFF;
  border: 1px solid #E5E7EB;
  border-radius: 12px;
  box-sizing: border-box;

  display: grid;
  grid-template-columns: 155px 200px 190px 132px 132px minmax(240px, 1fr) auto;
  align-items: end;
  gap: 10px;

  @media (max-width: 1260px) {
    grid-template-columns: 155px 200px 190px 132px 132px auto;

    /* El buscador pasa a segunda línea y ocupa casi todo */
    > div:nth-child(6) {
      grid-column: 1 / 6;
    }

    > button {
      grid-column: 6 / 7;
    }
  }

  @media (max-width: 980px) {
    grid-template-columns: repeat(3, minmax(0, 1fr));

    > div:nth-child(6) {
      grid-column: 1 / 3;
    }

    > button {
      grid-column: 3 / 4;
    }
  }

  @media (max-width: 720px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));

    > div:nth-child(6) {
      grid-column: 1 / 3;
    }

    > button {
      grid-column: 1 / 3;
      justify-self: flex-start;
    }
  }

  @media (max-width: 520px) {
    grid-template-columns: 1fr;

    > div:nth-child(6),
    > button {
      grid-column: 1 / 2;
    }
  }
`;

export const ClinicalFilterGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  min-width: 0;
`;

export const ClinicalFilterLabel = styled.label`
  font-size: 10.5px;
  font-weight: 800;
  color: #7C8A89;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const ClinicalFilterSelect = styled.select`
  width: 100%;
  min-width: 0;
  height: 34px;
  border: 1.5px solid #E5E7EB;
  border-radius: 8px;
  background: #FAFBFB;
  color: #1F2D2D;
  padding: 0 10px;
  font-size: 12.5px;
  font-weight: 700;
  font-family: inherit;
  outline: none;
  box-sizing: border-box;

  &:focus {
    border-color: #23AAAF;
    background: #FFFFFF;
  }
`;

export const ClinicalFilterInput = styled.input`
  width: 100%;
  min-width: 0;
  height: 34px;
  border: 1.5px solid #E5E7EB;
  border-radius: 8px;
  background: #FAFBFB;
  color: #1F2D2D;
  padding: 0 10px;
  font-size: 12.5px;
  font-weight: 700;
  font-family: inherit;
  outline: none;
  box-sizing: border-box;

  &::placeholder {
    color: #7C8A89;
    opacity: 0.8;
  }

  &:focus {
    border-color: #23AAAF;
    background: #FFFFFF;
  }
`;

export const ClinicalClearFiltersButton = styled.button`
  height: 34px;
  border: none;
  background: transparent;
  color: #23AAAF;
  font-size: 12.5px;
  font-weight: 900;
  cursor: pointer;
  padding: 0 4px;
  font-family: inherit;
  align-self: end;

  &:disabled {
    color: #CBD5E1;
    cursor: default;
  }
`;

export const SessionTypesBlock = styled.div`
  margin-bottom: 12px;
`;

export const SessionTypesLabel = styled.div`
  font-size: 11px;
  font-weight: 800;
  color: #7C8A89;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  margin-bottom: 8px;
`;

export const SessionTypesPills = styled.div`
  display: flex;
  gap: 9px;
  flex-wrap: wrap;
`;

export const SessionTypePill = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 5px 12px;
  border-radius: 999px;
  font-size: 11.5px;
  font-weight: 700;
  white-space: nowrap;
  background: ${({ $variant }) => getSessionColor($variant, 'light')};
  color: ${({ $variant }) => getSessionColor($variant, 'base')};
  border: 1px solid ${({ $variant }) => getSessionColor($variant, 'border')};
`;

export const SessionIcon = styled.span`
  font-size: 13px;
  line-height: 1;
`;

export const ClinicalTableCard = styled.div`
  width: 100%;
  background: #FFFFFF;
  border: 1px solid #E6E6E4;
  border-radius: 10px;
  overflow: hidden;
  box-sizing: border-box;
`;

export const ClinicalTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  background: #FFFFFF;

  thead th {
    text-align: left;
    font-size: 10px;
    font-weight: 800;
    color: #7C8A89;
    text-transform: uppercase;
    letter-spacing: 0.35px;
    padding: 11px 8px;
    border-bottom: 2px solid #FF9B2A;
    background: #FFFFFF;
    white-space: nowrap;
  }

  tbody tr {
    border-bottom: 1px solid #E6E6E4;
    cursor: pointer;
  }

  tbody tr:last-child {
    border-bottom: none;
  }

  tbody tr:hover {
    background: #FAFBFA;
  }

  tbody tr:focus {
    outline: 2px solid rgba(35, 170, 175, 0.35);
    outline-offset: -2px;
  }

  td {
    padding: 12px 8px;
    font-size: 12.5px;
    color: #1F2D2D;
    vertical-align: middle;
    overflow: hidden;
  }

  th:nth-child(1),
  td:nth-child(1) {
    width: 94px;
  }

  th:nth-child(2),
  td:nth-child(2) {
    width: 50px;
  }

  th:nth-child(3),
  td:nth-child(3) {
    width: 205px;
  }

  th:nth-child(4),
  td:nth-child(4) {
    width: 96px;
  }

  /* Actividades queda flexible para ganar espacio */

  th:nth-child(6),
  td:nth-child(6) {
    width: 104px;
  }

  th:nth-child(7),
  td:nth-child(7) {
    width: 210px;
  }

  @media (max-width: 720px) {
    table-layout: auto;
    min-width: 760px;

    th:nth-child(7),
    td:nth-child(7) {
      width: 170px;
    }
  }
`;

export const TableScroll = styled.div`
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
`;

export const DateCell = styled.div`
  position: relative;
  padding-left: 12px;
  font-weight: 700;
  white-space: nowrap;
`;

export const RowAccent = styled.span`
  position: absolute;
  left: 0;
  top: -7px;
  bottom: -7px;
  width: 4px;
  border-radius: 999px;
  background: ${({ $variant }) => getSessionColor($variant, 'base')};
`;

export const SessionNumber = styled.span`
  color: #6B7280;
  font-weight: 800;
`;

export const TypeChip = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  max-width: 100%;
  padding: 5px 10px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 800;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  background: ${({ $variant }) => getSessionColor($variant, 'light')};
  color: ${({ $variant }) => getSessionColor($variant, 'base')};
`;

export const AssistanceText = styled.span`
  font-size: 13px;
  font-weight: ${({ $status }) => ($status === 'presente' || $status === 'ausente' ? 700 : 500)};
  color: ${({ $status }) => {
    if ($status === 'presente') return '#2F855A';
    if ($status === 'ausente') return '#BE4778';
    return '#7C8A89';
  }};
`;

export const ActivityChip = styled.span`
  display: inline-block;
  max-width: 100%;
  padding: 5px 10px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 800;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  background: ${({ $variant }) => getSessionColor($variant, 'light')};
  color: ${({ $variant }) => getSessionColor($variant, 'base')};
`;

export const ObservationText = styled.div`
  color: #7C8A89;
  font-size: 12.5px;
  line-height: 1.4;
  max-height: 38px;
  overflow: hidden;
`;

export const StatusBadge = styled.span`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  min-width: 74px;
  padding: 5px 9px;
  border-radius: 999px;
  font-size: 10px;
  font-weight: 900;
  text-transform: uppercase;
  letter-spacing: 0.2px;
  white-space: nowrap;

  background: ${({ $status }) => {
    if ($status === 'realizado' || $status === 'revisado' || $status === 'completado') return '#0B5654';
    if ($status === 'no_realizado') return '#FBE9F0';
    if ($status === 'cancelado') return '#F3F4F6';
    if ($status === 'reprogramado') return '#FDECD8';
    if ($status === 'incompleto') return '#F1ECFB';
    return '#FDECD8';
  }};

  color: ${({ $status }) => {
    if ($status === 'realizado' || $status === 'revisado' || $status === 'completado') return '#FFFFFF';
    if ($status === 'no_realizado') return '#BE4778';
    if ($status === 'cancelado') return '#6B7280';
    if ($status === 'reprogramado') return '#D97706';
    if ($status === 'incompleto') return '#8B5CF6';
    return '#F2994A';
  }};
`;

export const EditButton = styled.button`
  width: 30px;
  height: 30px;
  border-radius: 8px;
  border: 1px solid #D1D5DB;
  background: #FFFFFF;
  color: #6B7280;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  &:hover {
    background: #F3F4F6;
    color: #1F2D2D;
  }
`;

export const EmptyState = styled.div`
  padding: 28px;
  color: #7C8A89;
  text-align: center;
  font-size: 14px;
`;

export const ClinicalModalCard = styled.div`
  width: 100%;
  max-width: 760px;
  margin: 0 auto;
  background: #FFFFFF;
  border-radius: 18px;
  box-shadow: 0 18px 45px rgba(15, 23, 42, 0.22);
  box-sizing: border-box;
  overflow: hidden;
  border: 1px solid #E3EAEA;
`;

export const ClinicalModalHeader = styled.div`
  background: ${({ $variant }) => `
    linear-gradient(
      135deg,
      ${getSessionColor($variant, 'dark')} 0%,
      ${getSessionColor($variant, 'base')} 100%
    )
  `};
  color: #FFFFFF;
  padding: 22px 26px 20px;
  position: relative;
`;

export const ClinicalModalHeaderTop = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 14px;
`;

export const ClinicalModalPatientName = styled.p`
  margin: 0 0 8px;
  font-size: 21px;
  line-height: 1.2;
  font-weight: 900;
  color: #FFFFFF;
`;

export const ClinicalModalCloseRow = styled.div`
  position: absolute;
  top: 14px;
  right: 16px;
  z-index: 2;
`;

export const ClinicalModalCloseButton = styled.button`
  width: 30px;
  height: 30px;
  border: 1px solid rgba(255, 255, 255, 0.35);
  background: rgba(255, 255, 255, 0.14);
  border-radius: 999px;
  font-size: 23px;
  line-height: 1;
  color: #FFFFFF;
  cursor: pointer;
  padding: 0 0 2px;

  &:hover {
    background: rgba(255, 255, 255, 0.22);
  }

  &:disabled {
    opacity: 0.45;
    cursor: default;
  }
`;

export const ClinicalModalTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin: 0;
`;

export const ClinicalModalHeading = styled.h2`
  margin: 0;
  font-size: 19px;
  font-weight: 900;
  color: #FFFFFF;
`;

export const ClinicalModalMetaRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 14px;
  margin-top: 12px;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.92);
  font-weight: 700;
`;

export const ClinicalModalMetaItem = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 5px;
`;

export const ClinicalModalHeaderPill = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  width: fit-content;
  max-width: 100%;
  padding: 5px 12px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 900;
  white-space: nowrap;
  color: #FFFFFF;
  background: rgba(255, 255, 255, 0.16);
  border: 1px solid rgba(255, 255, 255, 0.34);
`;

export const ClinicalModalBody = styled.div`
  padding: 20px 26px 8px;
`;

export const ClinicalModalNotice = styled.div`
  margin-bottom: 16px;
  padding: 10px 13px;
  border-radius: 12px;
  background: #F8FAFC;
  color: #64748B;
  font-size: 12.5px;
  line-height: 1.35;
  border: 1px solid #E5E7EB;
`;

export const ClinicalModalSectionLabel = styled.p`
  margin: 0 0 14px;
  font-size: 11px;
  font-weight: 900;
  color: #8B5CF6;
  text-transform: uppercase;
  letter-spacing: 0.7px;
`;

export const ClinicalModalGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  margin-bottom: 14px;

  @media (max-width: 620px) {
    grid-template-columns: 1fr;
  }
`;

export const ClinicalModalField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
`;

export const ClinicalModalLabel = styled.label`
  font-size: 11px;
  font-weight: 900;
  color: #7C8A89;
  text-transform: uppercase;
  letter-spacing: 0.45px;
`;

export const ClinicalModalReadOnly = styled.div`
  min-height: 36px;
  border-radius: 10px;
  background: #F3F4F6;
  color: #374151;
  padding: 9px 11px;
  font-size: 13px;
  font-weight: 700;
  box-sizing: border-box;
  word-break: break-word;
`;

export const ClinicalModalInput = styled.input`
  width: 100%;
  min-width: 0;
  height: 38px;
  border: 1.5px solid #E5E7EB;
  border-radius: 10px;
  background: #FBFCFC;
  color: #1F2D2D;
  padding: 0 11px;
  font-size: 13px;
  font-weight: 700;
  font-family: inherit;
  outline: none;
  box-sizing: border-box;

  &::placeholder {
    color: #8A9699;
    opacity: 0.85;
  }

  &:focus {
    border-color: #8B5CF6;
    background: #FFFFFF;
    box-shadow: 0 0 0 3px rgba(139, 92, 246, 0.14);
  }
`;

export const ClinicalModalTextarea = styled.textarea`
  width: 100%;
  min-height: ${({ $height }) => $height || '110px'};
  resize: vertical;
  border: 1.5px solid #E5E7EB;
  border-radius: 12px;
  background: #FBFCFC;
  color: #374151;
  padding: 12px;
  font-size: 13px;
  font-family: inherit;
  font-weight: 600;
  line-height: 1.45;
  box-sizing: border-box;
  outline: none;

  &::placeholder {
    color: #8A9699;
    opacity: 0.85;
  }

  &:focus {
    border-color: #8B5CF6;
    box-shadow: 0 0 0 3px rgba(139, 92, 246, 0.14);
    background: #FFFFFF;
  }

  &:disabled {
    color: #6B7280;
    background: #F3F4F6;
    cursor: default;
  }
`;

export const ClinicalModalFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  padding: 16px 26px 22px;
  border-top: 1px solid #E5E7EB;
  margin-top: 8px;

  @media (max-width: 520px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

export const ClinicalModalFooterHint = styled.span`
  font-size: 12px;
  color: #7C8A89;
  line-height: 1.35;
`;

export const ClinicalModalActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;

  @media (max-width: 520px) {
    width: 100%;

    button {
      flex: 1;
    }
  }
`;

export const ClinicalCancelButton = styled.button`
  border: 1.5px solid #E5E7EB;
  background: #FFFFFF;
  color: ${({ disabled }) => (disabled ? '#CBD5E1' : '#6B7280')};
  border-radius: 10px;
  height: 38px;
  min-width: 110px;
  padding: 0 18px;
  font-size: 12px;
  font-weight: 900;
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};

  &:hover {
    background: ${({ disabled }) => (disabled ? '#FFFFFF' : '#F8FAFC')};
  }
`;

export const ClinicalSaveButton = styled.button`
  border: none;
  background: #0E7A7E;
  color: #FFFFFF;
  border-radius: 10px;
  height: 38px;
  min-width: 150px;
  padding: 0 18px;
  font-size: 12px;
  font-weight: 900;
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  opacity: ${({ disabled }) => (disabled ? 0.65 : 1)};
  box-shadow: 0 8px 18px rgba(14, 122, 126, 0.22);

  &:hover {
    background: ${({ disabled }) => (disabled ? '#0E7A7E' : '#0A5F62')};
  }
`;